import { render } from "./TemplateManagement.vue?vue&type=template&id=3f1a03bb&scoped=true"
import script from "./TemplateManagement.vue?vue&type=script&lang=js"
export * from "./TemplateManagement.vue?vue&type=script&lang=js"

import "./TemplateManagement.vue?vue&type=style&index=0&id=3f1a03bb&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1932422480/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1a03bb"]])

export default __exports__